import React from 'react';
import { isEmpty } from 'lodash';

import type { AiAction } from '~/components/AiChat/types';
import { useClaim } from '~/components/ClaimContainer';
import { ActionCardV2 } from '~/components/ClaimPage/CliveApp/CliveInsights/views/v2/ActionCardV2';
import { ClaimReferencesProvider } from '~/components/Clive/ClaimReferences/ClaimReferencesProvider';
import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';

interface ActionsV2Props {
  isLoading: boolean;
  /** Already display-filtered by `ActionsDataProvider`, which runs `getDisplayableActions` once. */
  actions: AiAction[];
  reloadActions: () => Promise<void>;
}

/**
 * The list of actions: renders each one with ActionCardV2. An action's explanation arrives with
 * its citations unresolved, so the list mounts the claim's reference cache for them.
 */
export const ActionsV2: React.FC<ActionsV2Props> = ({ isLoading, actions = [], reloadActions }) => {
  const { claim } = useClaim({ claimRequired: true });

  if (isLoading) {
    return <SkeletonTable rowsCount={5} columnsCount={1} />;
  }

  if (isEmpty(actions)) {
    return null;
  }

  return (
    <ClaimReferencesProvider claimId={claim.id}>
      <ul className="m-0 flex w-full flex-col gap-16 p-0">
        {actions.map((action) => (
          <ActionCardV2 action={action} key={action.action_id} onActionUpdate={reloadActions} />
        ))}
      </ul>
    </ClaimReferencesProvider>
  );
};
